/* Alivah — order bump "Complete o look" (08/10)
   Quando o cliente clica em comprar, as peças marcadas no bump entram no carrinho primeiro;
   em seguida o envio normal do tema continua (adiciona o produto principal e abre o carrinho
   já com tudo). O tamanho das peças acompanha o tamanho escolhido no produto principal,
   até o cliente mudar o tamanho de uma peça manualmente. */
(function () {
  if (window.__alvBump) return;
  window.__alvBump = true;

  function bumpBox() { return document.querySelector('[data-alv-bump]'); }
  function mainForm() {
    var b = bumpBox();
    if (!b) return null;
    var info = b.closest('.hdt-product-info, section') || document;
    return info.querySelector('form[action*="/cart/add"].hdt-product-form') ||
      document.querySelector('form[action*="/cart/add"].hdt-product-form');
  }
  function mainSize() {
    var picked = document.querySelector('.hdt-product-form__input input[type="radio"]:checked');
    if (picked) return picked.value;
    var sel = document.querySelector('.hdt-product-form__input select');
    return sel ? sel.value : null;
  }
  function syncSizes() {
    var b = bumpBox();
    if (!b) return;
    var size = mainSize();
    if (!size) return;
    b.querySelectorAll('[data-alv-bump-size]').forEach(function (s) {
      if (s.dataset.touched) return;
      var opt = [].find.call(s.options, function (o) { return o.dataset.size === size && !o.disabled; });
      if (opt) s.value = opt.value;
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-alv-bump-size]')) { t.dataset.touched = '1'; return; }
    if (t.closest && t.closest('.hdt-product-form__input')) setTimeout(syncSizes, 0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSizes);
  else syncSizes();

  // Fase de captura: roda antes do envio do tema (product-form escuta o submit no próprio form)
  document.addEventListener('submit', function (e) {
    var form = e.target, b = bumpBox();
    if (!b || form !== mainForm() || form.dataset.alvBumped) return;
    var items = [];
    b.querySelectorAll('.alv-bump__item').forEach(function (li) {
      var c = li.querySelector('[data-alv-bump-check]'), s = li.querySelector('[data-alv-bump-size]');
      if (c && c.checked && s && s.value) items.push({ id: Number(s.value), quantity: 1 });
    });
    if (!items.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).catch(function () {}).then(function () {
      b.querySelectorAll('[data-alv-bump-check]').forEach(function (c) { c.checked = false; });
      form.dataset.alvBumped = '1';
      try { form.requestSubmit(submitter || undefined); } finally { delete form.dataset.alvBumped; }
    });
  }, true);
})();
